import SEOPage from "./SEOPage";

export default function FemaleInfertilityTreatmentAmbala() {
  return (
    <SEOPage
      title="Female Infertility Treatment in Ambala"
      description="Comprehensive Female Infertility Treatment in Ambala including PCOS treatment, ovulation induction, fertility evaluation and IVF."
      canonical="https://amaanativf.com/female-infertility-treatment-in-ambala"
      heading="Female Infertility Treatment in Ambala"
      focusKeyword="Female Infertility Treatment in Ambala"
    />
  );
}